"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addCaptcha = void 0;
const config_1 = require("../../build-babel/auth/client/config");
const addCaptcha = (parentNode, buttonContainer, continueButton) => {
  const captchaDiv = document.createElement('div');
  captchaDiv.setAttribute('data-testid', 'captcha');
  captchaDiv.setAttribute('class', 'cf-turnstile');
  captchaDiv.setAttribute('data-callback', 'challengeOk');
  captchaDiv.setAttribute('data-sitekey', config_1.cloudflare.sitekey);
  if (buttonContainer && parentNode) {
    parentNode.insertBefore(captchaDiv, buttonContainer);
  }
  window.challengeOk = function (token) {
    if (token) {
      continueButton === null || continueButton === void 0 ? void 0 : continueButton.removeAttribute('disabled');
    }
  };
};
exports.addCaptcha = addCaptcha;
//# sourceMappingURL=captchaCode.js.map